import { useEffect, useRef, useState } from 'react';

const useIsTruncated = <T extends HTMLElement = HTMLElement>(
  dependency?: unknown
) => {
  const ref = useRef<T>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    if (ref.current) {
      const element = ref.current;
      setIsTruncated(
        element.scrollWidth > element.clientWidth ||
          element.scrollHeight > element.clientHeight
      );
    }
  }, [dependency]);

  return { ref, isTruncated };
};

export default useIsTruncated;
